<!-- KOKO HEADER -->
<header id="masthead" class="w-full border-primary-500 border-b"  itemscope itemtype="https://schema.org/WPHeader">
    <!-- YLÄRIVI (turkoosi tausta) -->
    <div id="topBar"
         class="hidden md:block bg-primary-500 h-[52px] mx-auto text-white transition-all duration-300 sticky z-[9001]"
         [class.mt-[-52px]]="isTopBarHidden">
        <div class="max-w-[1920px] mx-auto px-4 py-2 flex items-center justify-between z-[9001]">
            <!-- Vasemmalla: Purso Group -pudotusvalikko -->
            <nav aria-label="Yritysvalikko" itemscope itemtype="https://schema.org/SiteNavigationElement">
                <ul id="companyMenu" class="flex items-center space-x-4 z-50">
                    <li class="relative group font-semibold pl-2">
                        <button class="inline-flex items-center text-base font-bold uppercase tracking-widest leading-[33px] focus:outline-none"
                                aria-expanded="false">
                            Purso Group
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none"
                                 class="w-5 h-5 stroke-current [stroke-width:3]" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <!-- Alavalikko -->
                        <ul id="companiesList"
                            class="bg-primary-500 hidden absolute group-hover:block text-white py-2 shadow-md w-[14rem] mt-[-1px]"
                            aria-hidden="true">
                            <li>
                                <a href="https://pursoalucool.fi/"
                                   class="block py-[12px] px-[8px] text-[14px] tracking-widest hover:font-bold">
                                    Purso AluCool Oy
                                </a>
                            </li>
                            <li>
                                <a href="https://purso.fi/"
                                   class="block py-[12px] px-[8px] text-[14px] tracking-widest hover:font-bold">
                                    Purso Oy
                                </a>
                            </li>
                            <li>
                                <a href="https://www.nedal.com/"
                                   class="block py-[12px] px-[8px] text-[14px] tracking-widest hover:font-bold">
                                    Nedal Aluminium
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>

            <!-- Oikealla: Kieli & Kirjautuminen -->
            <div class="flex items-center space-x-6">
                <!-- Kielivalikko -->
                <div class="relative group">
                    <button class="inline-flex items-center hover:underline font-bold uppercase tracking-widest leading-[33px] focus:outline-none">
                        <!-- Uusi Globe-ikoni, käytetään sinun SVG:täsi -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 0 512 512" fill="currentColor"
                             class="w-4 h-4 text-white mr-2" aria-hidden="true">
                            <path d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"/>
                        </svg>

                        <!-- Näytetään nykyinen kieli, käytetään translate‑putkea -->
                        {{ currentLanguage() | translate }}

                        <!-- Nuoli-ikoni -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="none"
                             class="w-4 h-4 stroke-current [stroke-width:5] ml-1" stroke-linecap="round" stroke-linejoin="round"
                             aria-hidden="true">
                            <path d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    <!-- Kielivalikon alavalikko -->
                    <ul class="bg-primary-500 hidden absolute group-hover:block text-white py-2 shadow-md w-[14rem] mt-[-1px]"
                        aria-hidden="true">
                        <li>
                            <a href="#" (click)="translateService.use('fi')" lang="fi" hreflang="fi"
                               class="block py-[12px] px-[8px] text-[14px] tracking-widest hover:font-bold">
                                {{"fi" | translate}}
                            </a>
                        </li>
                        <li>
                            <a href="#" (click)="translateService.use('en')" lang="en-GB" hreflang="en-GB"
                               class="block py-[12px] px-[8px] text-[14px] tracking-widest hover:font-bold">
                                {{"en" | translate}}
                            </a>
                        </li>
                    </ul>
                </div>
                @if (!auth.isLoggedIn()){
                    <!-- Kirjaudu-painikkeet -->
                    <a [attr.aria-label]="'GLOBAL.LOGIN' | translate" [routerLink]="['/login']"
                       class="flex cursor-pointer items-center space-x-1 text-base font-bold uppercase tracking-widest leading-[33px] focus:outline-none">
                        <span>{{ "GLOBAL.LOGIN" | translate }}</span>
                    </a>
                    <a [attr.aria-label]="'GLOBAL.REGISTER' | translate" [routerLink]="['/register']"
                       class="flex cursor-pointer items-center space-x-1 text-base font-bold uppercase tracking-widest leading-[33px] focus:outline-none">
                        <span>{{ "GLOBAL.REGISTER" | translate }}</span>
                    </a>
                } @else {
                    <a [attr.aria-label]="'GLOBAL.DASHBOARD' | translate" [routerLink]="['/dashboard']"
                       class="flex cursor-pointer items-center space-x-1 text-base font-bold uppercase tracking-widest leading-[33px] focus:outline-none">
                        <span>{{ "GLOBAL.DASHBOARD" | translate }}</span>
                    </a>
                }
            </div>
        </div>
    </div>

    <!-- TOINEN RIVI (valkoinen tausta) -->
    <div id="secondBar" class="bg-white text-black sticky top-0 z-[1] transition-all duration-300">
            <navigation />
    </div>

</header>
